export default "__VITE_ASSET__6ce95cac__"